import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink, RouterLinkActive, RouterOutlet, Router } from '@angular/router';
import { ModalService } from '../../../../services/modal.service';

import { I18nTranslator } from '../../../../i18n/translate';
import { AROrgeCampaign, AROrgeOrder } from '../../../../models/agrorendement-orge.model';
import { CampaignYearPipe } from '../../../../pipes/campaignYear.pipe';
import { HectareConverterPipe } from '../../../../pipes/hectareConverter.pipe';
import { ListFarmsForOrderPipe, ListUsersForOrderPipe } from '../../../../pipes/orders.pipe';
import { AROrgeService } from '../../../../services/agrorendement-orge.service';
import { FarmService } from '../../../../services/farm.service';
import { OrganisationService } from '../../../../services/organisation.service';
import { OrderComponent } from '../common/orders.component';
import { AROrgeUtils } from './orge.utils';
import { TranslatePipe, TranslateDatePipe, TranslateWithPunctuationPipe } from '../../../../pipes/translate.pipe';
import { PaginationModule } from 'ngx-bootstrap/pagination';

@Component({
  standalone: true,
  selector: 'ar-orge-orders-cmp',
  templateUrl: '../common/orders.component.html',
  imports: [
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
    CommonModule,
    FormsModule,
    CampaignYearPipe,
    HectareConverterPipe,
    ListUsersForOrderPipe,
    ListFarmsForOrderPipe,
    TranslatePipe,
    TranslateDatePipe,
    TranslateWithPunctuationPipe,
    PaginationModule,
  ],
  providers: [AROrgeService, FarmService, OrganisationService],
})
export class AROrgeOrderComponent extends OrderComponent<AROrgeCampaign, AROrgeOrder> implements OnInit, AfterViewInit {
  @ViewChild('termCampaignFilter') termCampaignFilter: ElementRef;
  @ViewChild('termFarmFilter') termFarmFilter: ElementRef;
  @ViewChild('termOrganisationFilter') termOrganisationFilter: ElementRef;
  @ViewChild('allFilters', { static: true }) allFilters: ElementRef;

  constructor(
    protected service: AROrgeService,
    protected farmService: FarmService,
    protected organisationService: OrganisationService,
    protected i18nTranslator: I18nTranslator,
    protected router: Router,
    protected modal: ModalService,
  ) {
    super();
    this.specyString = this.i18nTranslator.translate('ar.orge.section');
    this.specyUrlPart = ['azote', 'orge'];
    this.specyOrderCode = 'ORDO';
  }

  isOrderEditable(order: AROrgeOrder): boolean {
    return AROrgeUtils.isOrderEditable(order);
  }
}
